import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable, Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { EndpointsService, NotificationService } from '../core/services';


@Injectable()
export class UserService {
    private static notificationService: any;
    constructor(
        private http: Http,
        private endpointsService: EndpointsService,
        private notificationService: NotificationService) {
        UserService.notificationService = notificationService;
    }

    public getUsers(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, firstName: string, lastName: string, email: string, userType: any): Observable<Response> {
        return this.http.get(this.endpointsService.GET_USERS_URL + "?sortFieldId=" + sortFieldId + "&sortAsc=" + sortAsc + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&firstName=" + firstName + "&lastName=" + lastName + "&email=" + email + "&userType=" + userType)
            .catch(this.handleError);
    }

    public createUser(firstName: string, lastName: string, email: string, userTypeId: number): Observable<Response> {
        return this.http.post(this.endpointsService.CREATE_USER_URL, { firstName, lastName, email, userTypeId, password: '' })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    public updateUser(id: number, firstName: string, lastName: string, email: string, userTypeId: number): Observable<Response> {
        return this.http.post(this.endpointsService.UPDATE_USER_URL, { id, firstName, lastName, email, userTypeId, password: '' })
            .map((response: Response) => { })
            .catch(this.handleError);
    }

    public deleteUser(userId: number): Observable<Response> {
        return this.http.delete(this.endpointsService.DELETE_USER_URL + '/' + userId)
            .catch(this.handleError);
    }

    public getAvailablePublisherIds(userId: number): Observable<Response> {
        return this.http.get(this.endpointsService.GET_AVAILABLE_PUBLISHERIDS_URL + '/' + userId)
            .catch(this.handleError);
    }

    public updatePublishers(publisherIds: Array<number>, userId: number): Observable<Response> {
        return this.http.post(this.endpointsService.UPDATE_PUBLISHERIDS_URL, { publisherIds, userId })
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        if (error.status === 400)
            UserService.notificationService.showError(error.json().message)
        else
            UserService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/users/users.service.ts